"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cExportTablePredefinedFilters = void 0;
exports.cExportTablePredefinedFilters = {
    userLists: 'userLists',
    /** For the User List export, the user list id to scope the results to */
    matchOnListId: 'matchOnListId',
    /** Whether to show historical connections in the Connection export */
    showOldConnections: 'showOldConnections',
    /** For the Entity export, the entity id to scope the results to */
    entityId: 'entityId',
    /** For the Entity export, the concept id to scope the results to */
    conceptId: 'conceptId',
    /** For the User export, the user id to scope the results to */
    accountId: 'accountId',
    createdBy: 'createdBy'
};
